import React from "react";
import VisitGridLoading from "./VisitGridLoading";
import VisitGridEmpty from "./VisitGridEmpty";
import VisitGridItems from "./VisitGridItems";

function VisitGrid(props) {
  const { children, items, loading } = props;
  let loadingChild = <p>ローディング中</p>;
  let emptyChild = <p>該当アイテムがありません</p>;
  let itemsChild = <div></div>;

  children.forEach((child, idx) => {
    if (child.type === VisitGridLoading) {
      loadingChild = child;
      return;
    } else if (child.type === VisitGridEmpty) {
      emptyChild = child;
      return;
    } else if (child.type === VisitGridItems) {
      itemsChild = child;
      return;
    }
    return;
  });

  return (
    <div className="w-full h-full overflow-auto bg-list-bg">
      <div className="w-full grid grid-cols-1 gap-4 pt-2 px-2">
        {loading ? loadingChild : items?.length === 0 ? emptyChild : itemsChild}
      </div>
    </div>
  );
}

export default VisitGrid;
